/* This file was created automatically, don't change it manually. */

import React, { forwardRef } from 'react';

import { ColorlessIconProps } from '../../types';
import { SVGContainer } from '../../SVGContainer';

const IconArrowUpBig8 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconArrowUpBig8(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 8 8" ref={ref}>
            <path
                d="m1.959 3.509 1.77-1.673v5.56h.667v-5.56l1.772 1.673.457-.485L4.063.604l-2.562 2.42.458.485Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconArrowUpBig12 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconArrowUpBig12(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 12 12" ref={ref}>
            <path
                d="m2.938 5.263 2.656-2.51v8.341h1v-8.34l2.657 2.509.687-.727L6.094.906l-3.843 3.63.687.727Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconArrowUpBig16 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconArrowUpBig16(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 16 16" ref={ref}>
            <path
                d="M3.916 7.017 7.46 3.672v11.12h1.333V3.672l3.542 3.345.916-.97-5.125-4.839-5.124 4.84.915.97Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconArrowUpBig20 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconArrowUpBig20(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 20 20" ref={ref}>
            <path
                d="m4.896 8.772 4.428-4.183V18.49h1.667V4.59l4.428 4.182 1.144-1.212-6.406-6.05-6.405 6.05 1.144 1.212Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconArrowUpBig24 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconArrowUpBig24(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 24 24" ref={ref}>
            <path
                d="m5.875 10.526 5.313-5.019v16.681h2V5.508l5.314 5.018 1.373-1.454-7.687-7.26-7.686 7.26 1.373 1.454Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

export const IconArrowUpBig = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconArrowUpBig(props, ref) {
    const { size = '16', role = 'supplementary' } = props;

    const iconProps = {
        ...props,
        size,
        ref,
        role,
        colorless: true,
    } as const;

    switch (size) {
        case '8':
            return <IconArrowUpBig8 {...iconProps} />;
        case '12':
            return <IconArrowUpBig12 {...iconProps} />;
        case '16':
            return <IconArrowUpBig16 {...iconProps} />;
        case '20':
            return <IconArrowUpBig20 {...iconProps} />;
        case '24':
            return <IconArrowUpBig24 {...iconProps} />;
        default:
            return <IconArrowUpBig24 {...iconProps} />;
    }
});
